import { jsx as t } from "react/jsx-runtime";
import g from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as o } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
const m = g.div`
  --badge-text-color: ${(e) => {
  if (e.emphasis === "high" || e.emphasis === void 0)
    return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.high;
  if (e.emphasis === "low")
    switch (e.type) {
      case "primary":
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.primary;
      case "neutral":
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.neutral;
      case "danger":
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.danger;
      case "success":
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.success;
      case "warning":
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.warning;
      default:
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.default;
    }
}};

  --badge-height: ${(e) => (e == null ? void 0 : e.size) && e.theme.components.badge.getBadgeSize(e.size, e.value)};

  --badge-min-width: ${(e) => (e == null ? void 0 : e.size) && e.theme.components.badge.getBadgeSize(e.size, e.value)};

  --badge-background-color: ${(e) => {
  if (e.emphasis === "high" || e.emphasis === void 0)
    switch (e.type) {
      case "primary":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.primary;
      case "neutral":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.neutral;
      case "danger":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.danger;
      case "success":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.success;
      case "warning":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.warning;
      default:
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.default;
    }
  else if (e.emphasis === "low")
    switch (e.type) {
      case "primary":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.primary;
      case "neutral":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.neutral;
      case "danger":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.danger;
      case "success":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.success;
      case "warning":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.warning;
      default:
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.default;
    }
}};
  --value-width: ${(e) => e.size === "small" ? e.theme.components.badge.BadgeContainer.valueWidth.small : e.theme.components.badge.BadgeContainer.valueWidth.default};
  padding: ${(e) => {
  var a;
  return ((a = e == null ? void 0 : e.value) == null ? void 0 : a.toString().length) === 1 || e != null && e.value ? e.theme.components.badge.BadgeContainer.padding.length[1] : e.theme.components.badge.BadgeContainer.padding.default;
}};

  display: ${(e) => e.theme.components.badge.BadgeContainer.display};
  justify-content: ${(e) => e.theme.components.badge.BadgeContainer.justifyContent};
  align-items: ${(e) => e.theme.components.badge.BadgeContainer.alignItems};
  height: var(--badge-height);
  width: ${(e) => e.theme.components.badge.BadgeContainer.width};
  min-width: var(--badge-min-width);
  border-radius: ${(e) => e.theme.components.badge.BadgeContainer.borderRadius};
  text-align: ${(e) => e.theme.components.badge.BadgeContainer.textAlign};
  background-color: var(--badge-background-color);
  box-sizing: ${(e) => e.theme.components.badge.BadgeContainer.boxSizing};
`, r = g.span`
  display: ${(e) => e.theme.components.badge.BadgeValue.display};
  justify-content: ${(e) => e.theme.components.badge.BadgeValue.justifyContent};
  align-items: ${(e) => e.theme.components.badge.BadgeValue.alignItems};
  width: ${(e) => e.theme.components.badge.BadgeValue.width};
  height: ${(e) => e.size === "small" ? e.theme.components.badge.BadgeValue.height.small : e.size === "medium" ? e.theme.components.badge.BadgeValue.height.medium : e.theme.components.badge.BadgeValue.height.large};
  ${(e) => {
  if (e.size === "small")
    return e.theme.components.badge.BadgeValue.textStyle.small;
  if (e.size === "medium")
    return e.theme.components.badge.BadgeValue.textStyle.medium;
  if (e.size === "large")
    return e.theme.components.badge.BadgeValue.textStyle.large;
}};
  color: var(--badge-text-color);
  text-align: ${(e) => e.theme.components.badge.BadgeValue.textAlign};
`;
function C({ size: e = "medium", emphasis: a = "high", type: d = "primary", ...n }) {
  const i = o({ label: "Badge" });
  return /* @__PURE__ */ t(
    m,
    {
      size: e,
      emphasis: a,
      type: d,
      ...n,
      ...i,
      children: /* @__PURE__ */ t(
        r,
        {
          role: "status",
          size: e,
          "aria-label": n.ariaLabel,
          "aria-live": "polite",
          children: n.value
        }
      )
    }
  );
}
export {
  C as Badge
};
